import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

function Home() {
  const navigate = useNavigate();

  const apps = [
    {
      id: 'nlp-sentiment',
      title: 'IMDB Sentiment Analyzer',
      description: 'NLP-powered movie review sentiment classification using machine learning',
      tech: ['Python', 'Flask', 'React', 'TF-IDF', 'Linear SVC'],
      path: '/nlp-sentiment',
      color: '#4CAF50'
    },
    {
      id: 'nba-team',
      title: 'NBA Team Optimizer',
      description: 'Deep neural network (MLP) to build optimal 5-player basketball teams with position enforcement',
      tech: ['Python', 'NumPy', 'ANN', 'React', 'Canvas'],
      path: '/nba-team',
      color: '#EF4444'
    },
    {
      id: 'image-classifier',
      title: 'Cats vs Dogs Classifier',
      description: 'Deep CNN image classifier with 84% accuracy. Upload images or try random samples from the dataset',
      tech: ['Python', 'TensorFlow', 'CNN', 'React', 'Keras'],
      path: '/image-classifier',
      color: '#667eea'
    },
    {
      id: 'lstm-predictor',
      title: 'LSTM Next Word Predictor',
      description: 'Recurrent neural network trained on Reddit comments for intelligent text completion and next-word prediction',
      tech: ['Python', 'TensorFlow', 'LSTM', 'GloVe', 'React'],
      path: '/lstm-predictor',
      color: '#764ba2'
    },
    {
      id: 'gan-flower',
      title: 'GAN Flower Generator',
      description: 'Deep Convolutional GAN trained on Flowers102 dataset to generate unique synthetic flower images from random noise',
      tech: ['Python', 'PyTorch', 'DCGAN', 'React', 'PIL'],
      path: '/gan-flower',
      color: '#f5576c'
    },
    {
      id: 'energy-forecaster',
      title: 'Energy Consumption Forecaster',
      description: 'LSTM-based time series forecasting on 4 years of household energy data with interactive date selection and 1-24 hour predictions',
      tech: ['Python', 'TensorFlow', 'LSTM', 'React', 'Chart.js'],
      path: '/energy-forecaster',
      color: '#667eea'
    }
  ];

  return (
    <div className="home-container">
      <header className="home-header">
        <h1>Preston Brownlee</h1>
        <h2>Application Portfolio</h2>
        <p>Select an application to explore</p>
      </header>

      <div className="apps-grid">
        {apps.map((app) => (
          <div
            key={app.id}
            className="app-card"
            onClick={() => navigate(app.path)}
            style={{ borderLeftColor: app.color }}
          >
            <h3>{app.title}</h3>
            <p className="app-description">{app.description}</p>
            <div className="tech-stack">
              {app.tech.map((tech, index) => (
                <span key={index} className="tech-badge">{tech}</span>
              ))}
            </div>
            <button className="launch-btn" style={{ backgroundColor: app.color }}>
              Launch App →
            </button>
          </div>
        ))}
      </div>

      <footer className="home-footer">
        <p>Built with React and Flask | CST-435 Portfolio</p>
      </footer>
    </div>
  );
}

export default Home;
